import React from 'react';

import { cn } from '@/lib/utils';

export const BentoCard: React.FC<{
  children: React.ReactNode;
  className?: string;
  title?: string;
  icon?: React.ElementType;
  action?: React.ReactNode;
  noPadding?: boolean;
}> = ({ children, className = '', title, icon: Icon, action, noPadding }) => (
  <div
    className={cn(
      'flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0_2px_8px_rgba(0,0,0,0.04)] ring-1 ring-black/5 transition-all duration-300 hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)]',
      className,
    )}
  >
    {(title || action) && (
      <div className="flex items-center justify-between px-6 pt-6 pb-2">
        {title && (
          <div className="flex items-center gap-2 text-zinc-500">
            {Icon && <Icon className="h-4 w-4" />}
            <h3 className="text-xs font-bold uppercase tracking-wider text-zinc-900/80">
              {title}
            </h3>
          </div>
        )}
        {action && <div>{action}</div>}
      </div>
    )}
    <div
      className={cn(
        'flex flex-col flex-1',
        noPadding ? '' : title || action ? 'p-6 pt-2' : 'p-6',
      )}
    >
      {children}
    </div>
  </div>
);
